import React from 'react';
import './WristBandStyle.css';
import Barcode from 'react-barcode';
import Typography from '@mui/material/Typography';

const WristBandDesign = React.forwardRef((props, ref) => {
  const {ticket} = props;
  const ticketNo = ticket?.ticket_no;

  return (<div>
      <Typography className={'justify'} sx={{fontWeight: 700}}>
        National Museum of Bhutan
      </Typography>
      <div ref={ref} className="ticket-template-rp">
        <Barcode format={'EAN13'} font={'monospace'} fontSize={50} height={189} ean128={true} width={5.6}
                 value={ticketNo}/>
      </div>
    </div>);
});

export default WristBandDesign;